import { useTranslation } from 'react-i18next';
import { InfiosChip, InfiosIcon, InfiosIconButton } from '@infios/uikit/react';
import styles from './ChatHeader.module.css';

interface ChatHeaderProps {
  statusText: string;
  online: boolean;
  onNewChat: () => void;
  /** Only offered in standalone/dev mode — a host-embedded session's auth is the host's to manage. */
  onLogout?: () => void;
}

export function ChatHeader({ statusText, online, onNewChat, onLogout }: ChatHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <span className={styles.avatar} aria-hidden>
          <InfiosIcon name="robot" />
          <span className={`${styles.statusDot} ${online ? styles.dotOnline : styles.dotOffline}`} />
        </span>
        <div className={styles.info}>
          <span className={styles.name}>{t('ChatbotUI.AgentName')}</span>
          <span className={styles.sub}>{statusText}</span>
        </div>
      </div>

      <div className={styles.right}>
        <InfiosChip
          size="compact"
          backgroundColor="var(--chat-accent-subtle)"
          textColor="var(--chat-text)"
        >
          {t('ChatbotUI.HeaderContext')}
        </InfiosChip>
        <InfiosIconButton
          name="refresh"
          label={t('ChatbotUI.NewChat')}
          title={t('ChatbotUI.NewChat')}
          onClick={onNewChat}
        />
        {onLogout ? (
          <InfiosIconButton
            name="logout"
            label={t('ChatbotUI.LogOut')}
            title={t('ChatbotUI.LogOut')}
            onClick={onLogout}
          />
        ) : null}
      </div>
    </header>
  );
}
